<script setup lang="ts">
import BaseAlert from "@/components/Base/Alert.vue";
import FoldersCreateItemDropdown from "@/components/Folders/CreateItemDropdown.vue";

import image from "/images/undraw_image__folder_re.svg";

const { t } = useI18n();

type Props = {
  title?: string;
  text?: string;
};

defineProps<Props>();
</script>

<template>
  <BaseAlert :title="title" state="light">
    <template #default>
      <span>{{ text }}</span>
    </template>
    <template #actions>
      <FoldersCreateItemDropdown
        :label="t('folders.hints.noItems.addContent')"
        direction="right"
      />
    </template>
    <template #second-column>
      <img :src="image" class="image" alt="image folder" />
    </template>
  </BaseAlert>
</template>

<style lang="scss" scoped>
.image {
  width: 90px;
  margin-left: $spacer-5;

  @include media-breakpoint-down(lg) {
    margin-left: $spacer-4;
  }
}
</style>
